import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import type { AlertCode } from 'types';

export const ALERTS_TRANSLATIONS: Partial<
  Record<AlertCode, MessageDescriptor>
> = {
  Offline: msg`Аппарат давно не выходил на связь. Возможно, с ним есть определенные проблемы`,
  WaterIsOver: msg`Закончилась вода в баке. Возможно, отключен водопровод или имеются другие проблемы с аппаратом`,
  WaterPressureLow: msg`Сработал датчик низкого давления`,
  DoorIsOpen: msg`Сработал датчик открытия двери`,
  NoSales2h: msg`В аппарате более 2 часов не было продаж. Возможно, с ним есть определенные проблемы`,
  NoBankcardSales2h: msg`Нет платежей по каналу безналичная оплата (оплата банковской картой) более 2x часов`,
  ExchangeIsOver: msg`Кончилась сдача`,
  SimBalanceLow: msg`Малое количество средств на балансе SIM карты`,
  TankMinLevel: msg`Сработал датчик малого уровня воды в баке`,
  FiscalError: msg`Ошибка фискального сервера`,
  BillValidatorError: msg`Ошибка купюроприемника`,
  HopperError: msg`Ошибка монетоприемника`,
  RebootRequired: msg`Для корректной работы оборудования вам необходимо его перезагрузить`
};
